export interface PageModuleGroup {
  groupId: string;
  moduleDtos: ModuleDto[];
}

export interface ModuleDto {
  type: number; // SettingsModuleType
  title: string;
  subTitle: string;
  iconLink: string;
  actionLink: string;
  extra: string;
}

export const SettingsModuleType = {
  logout: -1, // 退出登录：客户端自定义
  unknown: 0, // 错误
  mycoupons: 1, // 优惠券
  invitingfriends: 2, // 邀请奖励
  collect: 3, // 店铺收藏
  myorders: 4, // 我的订单
  mypaymentmethod: 5, // 支付方式
  myaddress: 6, // 地址管理
  help: 7, // 客服中心
  languagesetting: 8, // 语言设置
  pushsetting: 9, // 推送设置
  emailsetting: 10, // 邮件订阅开关
  cache: 11, // 清除缓存
  aboutkeeta: 12, // 关于
  rating: 13, // 喜欢
  userpolicy: 14, // 使用条款
  privacypolicy: 15, // 隐私政策
  diagnosis: 16, // 网络检测
  activityCenter: 17, // 个人中心活动中心入口
  settings: 19, //设置
  wallet: 21, // 钱包
  keetaCard: 20, //keeta card
  scanQrcode: 31, // 扫描二维码入口
  ontimedelivery: 32, // 准时保
  memReloc: 33, // 会员搬家
  enterpriseAllowance: 34, //企业津贴
  personalizedRecommendation: -999, //个性化推荐，前端实现为满足国内上架要求，后续后段支持这个功能后，可删除
};

// 更新设置信息
export const SettingsUserInfoType = {
  clientLocale: 'SET_LOCALE', // 语言
  pushSwitch: 'SET_PUSH_SWITCH', // 推送
  emailSwitch: 'SET_EMAIL_SWITCH', // 邮件订阅
};

export interface MineRichTextItem {
  type: string;
  text: string;
  backgroundColor?: string;
  color?: string;
  fontFamily?: string;
  fontSize?: number;
  fontWeight?: string;
  fontStyle?: string;
  textDecoration?: string;
}

export const MineCids = {
  mine: 'c_waimai_c_overseas_oebhyydh',
  settings: 'c_waimai_c_overseas_g7y42txb',
  about: 'c_waimai_c_overseas_kf29evuz',
  addressManager: 'c_waimai_c_overseas_syl34kom',
};

export const MineMVBid = {
  [SettingsModuleType.logout]: 'b_waimai_c_overseas_s74ckulb_mv', // 退出登录
  [SettingsModuleType.mycoupons]: 'b_waimai_c_overseas_wrbagchm_mv', // 优惠券
  [SettingsModuleType.invitingfriends]: 'b_waimai_c_overseas_7ymvy43u_mv', // 邀请奖励
  [SettingsModuleType.collect]: 'b_waimai_c_overseas_uc5xoufc_mv', // 店铺收藏
  [SettingsModuleType.myorders]: 'b_waimai_c_overseas_15x2vqgd_mv', // 我的订单
  [SettingsModuleType.mypaymentmethod]: 'b_waimai_c_overseas_ciabtc91_mv', // 支付方式
  [SettingsModuleType.myaddress]: 'b_waimai_c_overseas_w2178pq8_mv', // 地址管理
  [SettingsModuleType.help]: 'b_waimai_c_overseas_quo3fxug_mv', // 客服中心
  [SettingsModuleType.languagesetting]: 'b_waimai_c_overseas_5tirb4kj_mv', // 语言设置
  [SettingsModuleType.pushsetting]: 'b_waimai_c_overseas_9owikegs_mv', // 推送设置
  [SettingsModuleType.emailsetting]: 'b_waimai_c_overseas_jmqteg17_mv', // 邮件订阅开关
  [SettingsModuleType.cache]: 'b_waimai_c_overseas_rfweeamc_mv', // 清除缓存
  [SettingsModuleType.aboutkeeta]: 'b_waimai_c_overseas_g368o0hd_mv', // 关于
  [SettingsModuleType.rating]: 'b_waimai_c_overseas_2qojwi9d_mv', // 喜欢
  [SettingsModuleType.userpolicy]: 'b_waimai_c_overseas_j1tza1jl_mv', // 使用条款
  [SettingsModuleType.privacypolicy]: 'b_waimai_c_overseas_bxo8gg1k_mv', // 隐私政策
  [SettingsModuleType.activityCenter]: 'b_sailor_c_vhc87uid_mv', // 个人中心活动中心入口
  [SettingsModuleType.settings]: 'b_waimai_c_overseas_fdekhcu7_mv', // 设置
  [SettingsModuleType.wallet]: 'b_sailor_c_nu5i27ik_mv', // 钱包
  [SettingsModuleType.ontimedelivery]: 'b_sailor_c_rrrwaqmp_mv', // 准时保
  [SettingsModuleType.memReloc]: 'b_sailor_c_5hen0ydo_mv', //会员搬家
  [SettingsModuleType.enterpriseAllowance]: 'b_sailor_c_rl2qiqxl_mv', // 企业津贴
};

export const MineMCBid = {
  [SettingsModuleType.logout]: 'b_waimai_c_overseas_s74ckulb_mc', // 退出登录
  [SettingsModuleType.mycoupons]: 'b_waimai_c_overseas_wrbagchm_mc', // 优惠券
  [SettingsModuleType.invitingfriends]: 'b_waimai_c_overseas_7ymvy43u_mc', // 邀请奖励
  [SettingsModuleType.collect]: 'b_waimai_c_overseas_uc5xoufc_mc', // 店铺收藏
  [SettingsModuleType.myorders]: 'b_waimai_c_overseas_15x2vqgd_mc', // 我的订单
  [SettingsModuleType.mypaymentmethod]: 'b_waimai_c_overseas_ciabtc91_mc', // 支付方式
  [SettingsModuleType.myaddress]: 'b_waimai_c_overseas_w2178pq8_mc', // 地址管理
  [SettingsModuleType.help]: 'b_waimai_c_overseas_quo3fxug_mc', // 客服中心
  [SettingsModuleType.languagesetting]: 'b_waimai_c_overseas_5tirb4kj_mc', // 语言设置
  [SettingsModuleType.pushsetting]: 'b_waimai_c_overseas_9owikegs_mc', // 推送设置
  [SettingsModuleType.emailsetting]: 'b_waimai_c_overseas_jmqteg17_mc', // 邮件订阅开关
  [SettingsModuleType.cache]: 'b_waimai_c_overseas_rfweeamc_mc', // 清除缓存
  [SettingsModuleType.aboutkeeta]: 'b_waimai_c_overseas_g368o0hd_mc', // 关于
  [SettingsModuleType.rating]: 'b_waimai_c_overseas_2qojwi9d_mc', // 喜欢
  [SettingsModuleType.userpolicy]: 'b_waimai_c_overseas_j1tza1jl_mc', // 使用条款
  [SettingsModuleType.privacypolicy]: 'b_waimai_c_overseas_bxo8gg1k_mc', // 隐私政策
  [SettingsModuleType.activityCenter]: 'b_sailor_c_vhc87uid_mc', // 个人中心活动中心入口
  [SettingsModuleType.settings]: 'b_waimai_c_overseas_fdekhcu7_mc', // 设置
  [SettingsModuleType.wallet]: 'b_sailor_c_nu5i27ik_mc', // 钱包
  [SettingsModuleType.ontimedelivery]: 'b_sailor_c_rrrwaqmp_mc', // 准时保
  [SettingsModuleType.memReloc]: 'b_sailor_c_5hen0ydo_mc', //会员搬家
  [SettingsModuleType.enterpriseAllowance]: 'b_sailor_c_rl2qiqxl_mc', // 企业津贴
};
